import React from 'react';
import "./CommonDivWidget.css"
const CommonDivWidget = (props) => {
    return (
        <div className="common-background">
            {props.children}
        </div>
    );
};

export default CommonDivWidget;